/*
 * Trafford product-story scroll animation.
 * Each story block has a single image, so instead of the two-image counter-motion
 * used on the editorial/feature blocks, we alternate the direction per block: the
 * default (left-image) blocks zoom IN (scale 1.0 -> 1.15) while the alternating
 * (right-image) blocks zoom OUT (1.15 -> 1.0), scrubbed to scroll. Consecutive
 * blocks move opposite ways. Requires GSAP + ScrollTrigger (loaded in theme.liquid).
 * No-op without them, in the theme editor, or when the visitor prefers reduced motion.
 */
(function () {
  function setupCard(card) {
    if (card.dataset.tStoryInit === '1') return;
    var img = card.querySelector('.twc-story__img');
    if (!img) return;

    // alternating (right-image) cards zoom out; default cards zoom in
    var zoomOut = card.classList.contains('twc-story__card--alt');
    var from = zoomOut ? 1.15 : 1;
    var to = zoomOut ? 1 : 1.15;

    window.gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
        invalidateOnRefresh: true
      }
    }).fromTo(img, { scale: from }, { scale: to, ease: 'none' }, 0);

    card.dataset.tStoryInit = '1';
  }

  function inEditor() {
    return window.Shopify && window.Shopify.designMode;
  }

  function init(root) {
    if (inEditor()) return;
    if (!window.gsap || !window.ScrollTrigger) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    (root || document).querySelectorAll('.twc-story__card').forEach(setupCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('load', function () {
    if (!inEditor() && window.ScrollTrigger) window.ScrollTrigger.refresh();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    if (!inEditor() && window.ScrollTrigger) window.ScrollTrigger.refresh();
  });
})();
